import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormGroup, styled, Switch, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { t } from "i18next";

export const LivisCustomSwitch = styled(Switch)(({ theme, name, checked }) => ({
  width: name === "mask-switch" ? 35 : 32,
  height: 20,
  padding: 0,
  display: "flex",
  ...(name == "mask-switch" && {
    border: `1px solid ${!checked ? "white" : "gray" }`,
    borderRadius: "1rem",
    alignItems: "center",
    display: "flex",
    height: "1.79rem",
  }),
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 50,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1A26C1",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 16,
    height: 16,
    borderRadius: 8,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 10,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const LivisSwitch = (props: any) => {


  const {
    id,
    name,
    label,
    register,
    rules,
    setValue,
    setStateVal,
    value,
    state_hide,
    activeLabel,
    inactiveLabel,
    onChange = () => {return},
  } = props;
  const [checked, setChecked] = useState(value);

  // Sync internal state when value prop changes
  useEffect(() => {
    setChecked(value);
  }, [value]);

  /**
   * Toggles the state value and updates the form with the new checked value.
   */
  const handleCheck = () => {
    setStateVal(!checked);
    setValue(name, !checked);
    setChecked(!checked);

    console.log(name, !checked)
  };

  /**
   * Handles keydown events for the input element, triggering a check action on "Enter" key press.
   * @param {React.KeyboardEvent<HTMLInputElement>} e - The keydown event.
   */
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Handle keydown event here if needed
    if (e.key == "Enter") {
      handleCheck();
      e.preventDefault();
    }
  };

 

  return (
  <FormGroup>
    <Stack direction="row" spacing={1} alignItems="center">
      {label && <Typography className="livis-switch-label">{label}</Typography>}
      <LivisCustomSwitch
        {...register(name, rules)}
        id={id}
        name={name}
        onKeyDown={handleKeyDown}
        checked={checked}
        onChange={handleCheck}
        inputProps={{ "aria-label": "livis custom switch" }}
      />
        {!state_hide ? (
          name === "training_type" ? (
            <Typography>{checked ? t("Segmentation") : t("Object Detection")}</Typography>
          ) : (
            // <Typography>{checked ? t(activeLabel) : t(inactiveLabel)}</Typography>
            <Typography>
              {checked ? t(activeLabel || "Active") : t(inactiveLabel || "Inactive")}
            </Typography>
          )
        ) : null}
      </Stack>
    </FormGroup>
);
};

LivisSwitch.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  register: PropTypes.any,
  rules: PropTypes.any,
  setValue: PropTypes.func,
  value: PropTypes.any,
  state_hide: PropTypes.bool,
  setStateVal: PropTypes.any,
  activeLabel: PropTypes.string,
    inactiveLabel: PropTypes.string,
};

LivisSwitch.defaultProps = {
  register: () => {
    null;
  },
  label: "",
  state_hide: false,
  setStateVal: () => {
    null;
  },
  setValue: () => {
    null;
  },
};

export default LivisSwitch;
